export class UsersPermissions {
	constructor( {
		see = false,
		invite = false,
		editRole = false,
		destroy = false
	} ) {
		this.see = see;
		this.invite = invite;
		this.editRole = editRole;
		this.destroy = destroy;
	}
}

export const workspaceOwnerUsersPermissions = new UsersPermissions( {
	see: true, invite: true, editRole: true, destroy: true
} );
export const adminUsersPermissions = new UsersPermissions( {
	see: true
} );
export const collaboratorUsersPermissions = new UsersPermissions( {
	see: true
} );
